<template>
  <div id="delphi-container" />
</template>

<script>
import { DelphiSSOSender } from "./delphi-sso";

const VersionConfigs = {
  Core: "f9a7e463-9025-4969-a464-e37e1dfebd19",
  Connect: '37c17046-36c0-4f8d-9434-f31d926e9531',
  Holistic: '7bcc5b85-7a74-42a0-a0bc-97b94b5bb831',
  Pro: '4837b76a-e49e-4832-9413-d3907c90b29b'
};

export default {
  props: {
    version: {
      type: String,
      default: null,
      validator: (value) => ["Core", "Connect", "Holistic", "Pro"].includes(value),
    },
    delphiToken: {
      type: String,
      default: null,
    },
    shouldShowDelphi: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      hasLoggedIn: false,
      scriptElement: null,
    };
  },

  watch: {
    delphiToken() {
      if (this.hasLoggedIn) return;
      this.initializeSSO();
    },

    shouldShowDelphi(val) {
      if (!val) this.cleanup();
      else this.initialize();
    },
  },

  mounted() {
    this.initialize();
  },

  beforeDestroy() {
    this.cleanup();
  },

  methods: {
    initializeSSO() {
      if (this.hasLoggedIn || !this.delphiToken) return;

      // Try first
      new DelphiSSOSender("delphi-bubble-container", this.delphiToken)
        .initialize()
        .catch((e) => {
          console.error(e);
        });

      // Try again in a bit
      setTimeout(() => {
        new DelphiSSOSender("delphi-bubble-container", this.delphiToken)
          .initialize()
          .then(() => {
            this.hasLoggedIn = true;
          });
      }, 1500);

      // Final try in 5s, just in case
      setTimeout(() => {
        new DelphiSSOSender("delphi-bubble-container", this.delphiToken)
          .initialize()
          .then(() => {
            this.hasLoggedIn = true;
          });
      }, 5000);
    },

    initialize() {
      if (!this.shouldShowDelphi) return;
      this.cleanup();
      const config = VersionConfigs[this.version || "Core"];

      const script = document.createElement("script");
      script.id = "delphi-bubble-script";
      script.type = "text/javascript";
      script.textContent = `
        window.delphi = {...(window.delphi ?? {}) };
        window.delphi.bubble = {
          config: "${config}",
          overrides: {
            landingPage: "OVERVIEW",
          },
          trigger: {
            color: "#c25354",
          },
        };
      `;

      this.scriptElement = script;

      document.getElementById("delphi-container").appendChild(script);

      const delphiScript = document.createElement("script");
      delphiScript.id = "delphi-bubble-bootstrap";
      delphiScript.src = "https://embed.delphi.ai/loader.js";
      document.getElementById("delphi-container").appendChild(delphiScript);

      this.initializeSSO();
    },

    cleanup() {
      document.getElementById("delphi-bubble-container")?.remove();
      document.getElementById("delphi-bubble-script")?.remove();
      document.getElementById("delphi-bubble-bootstrap")?.remove();
      this.hasLoggedIn = false;
    },
  },
};
</script>
